import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../utils/error-handler';
import { Plate } from '../models/plate';
import { Sample } from '../models/sample';
import { MaPlatePreparationService } from '../ma-plate-preparation/ma-plate-preparation.service';
import { MessagesService } from '../messages/messages.service';


@Component({
  selector: 'app-ma-beadchip-view',
  templateUrl: './ma-beadchip-view.component.html',
  styleUrls: ['./ma-beadchip-view.component.css']
})
export class MaBeadchipViewComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;
  puid: string;
  color: string = "white";
  selectedLabId: string;
  plateMap = new Map();

  map = new Map<string, string>();

  circleBorder: string = 'black';
  circleStroke: string = '3';

  columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  columnHeaders384 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
  rowHeaders384 = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'];

  samplePopVisible = false;
  samplePosition = '';
  sourcePlateID: string = ''
  sourcePlateList: string[] = []
  sampleID: string = ''
  orgPosition: string = ''
  sampleConcentration: string = '';

  @Input() selectedBeadchipData: Plate;
  selectedBeadChipSamples: Sample[]

  sampleComments: any[]
  commentView: boolean = false;
  newComment: string = '';
  sampleHoverVisible: boolean = false

  constructor(private platePreparationService: MaPlatePreparationService, private _messagesService: MessagesService) { }

  ngOnInit() {
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.puid = localStorage.getItem("PUID");
    this.mapSamplesAndPositions()
    for (let i = 0; i < this.selectedBeadchipData.sourcePlates.length; i++) {
      this.sourcePlateList.push(this.selectedBeadchipData.sourcePlates[i]['plateID'])
    }
  }

  getToolTip(row: number, col: number) {
    if (this.plateMap.has(this.getPosition(row, col))) {
      return 'Plate-ID: ' + this.sourcePlateID + '\n' + 'Sample-ID: ' + this.sampleID + '\n' + 'Position: ' + this.samplePosition;
    }
  }

  mouseEnter(row: number, col: number) {
    if (this.plateMap.has(this.getPosition(row, col))) {
      this.samplePosition = this.plateMap.get(this.getPosition(row, col)).position;
      this.sampleID = this.plateMap.get(this.getPosition(row, col)).sampleID;
      this.sourcePlateID = this.plateMap.get(this.getPosition(row, col)).sourcePlateID;
      this.sampleHoverVisible = true
    }
    else {
      this.samplePosition = ''
      this.sampleID = ''
      this.sampleHoverVisible = false
    }
  }

  mouseLeave(row: number, col: number) {
    this.sampleHoverVisible = false
  }


  convert384To96Index(rowVal, colVal, sample) {
    if (rowVal % 2 == 0 && colVal % 2 == 0) {
      return this.createMapOutOfCovidSamplesDifferentMap(rowVal, colVal, 0, 0, 2)
    }
    else if (rowVal % 2 != 0 && colVal % 2 == 0) {
      return this.createMapOutOfCovidSamplesDifferentMap(rowVal, colVal, 1, 0, 2)
    }
    else if (rowVal % 2 == 0 && colVal % 2 != 0) {
      return this.createMapOutOfCovidSamplesDifferentMap(rowVal, colVal, 0, 1, 2)
    }
    else if (rowVal % 2 != 0 && colVal % 2 != 0) {
      return this.createMapOutOfCovidSamplesDifferentMap(rowVal, colVal, 1, 1, 2)
    }
  }

  getPosition96(row, col) {
    let pos = ''
    pos = pos + this.rowHeaders[row] + this.columnHeaders[col]
    return pos
  }

  createMapOutOfCovidSamplesDifferentMap(rowVal, colVal, rowAdder: number, colAdder: number, divider: number) {
    let posRow = (rowVal + rowAdder) / divider;
    let posCol = (colVal + colAdder) / divider;
    return this.getPosition96(posRow, posCol);
  }

  mapSamplesAndPositions() {
    this.selectedBeadChipSamples = this.selectedBeadchipData.samples
    if(this.selectedBeadChipSamples.length>0){
      this.selectedBeadChipSamples.map(item => {
        this.plateMap.set(item.position, item)
      })
    }
  }

  getQuadrant(row: number, col: number) {
    if (this.plateMap.has(this.getPosition(row, col)) && (this.samplePopVisible || this.sampleHoverVisible) && this.samplePosition == this.plateMap.get(this.getPosition(row, col)).position) {
      if (row % 2 == 0 && col % 2 == 0 && this.plateMap.get(this.getPosition(row, col))) {
        //plate1
        return {
          "border": "2px solid #E4B309",
        };
      }
      else if (row % 2 == 0 && col % 2 != 0 && this.plateMap.get(this.getPosition(row, col))) {
        //plate2
        return {
          "border": "2px solid #0FA20F",
        };
      }
      else if (row % 2 != 0 && col % 2 == 0 && this.plateMap.get(this.getPosition(row, col))) {
        //plate3
        return {
          "border": "2px solid #BC66BC",
        };
      }
      else if (row % 2 != 0 && col % 2 != 0 && this.plateMap.get(this.getPosition(row, col))) {
        //plate4
        return {
          "border": "2px solid #2AC6C6",
        };
      }
      else {
        //none
        return {
          "border": "2px solid white",
        };
      }
    }
  }

  showSamplePopUp(row: number, col: number) {
    if (this.plateMap.has(this.getPosition(row, col))) {
      this.samplePosition = this.plateMap.get(this.getPosition(row, col)).position;
      this.sampleID = this.plateMap.get(this.getPosition(row, col)).sampleID;
      this.sourcePlateID = this.plateMap.get(this.getPosition(row, col)).sourcePlateID;
      this.platePreparationService.getSampleComments(this.selectedLabId, this.sampleID).subscribe(res => {
        if (res.data) {
          this.sampleComments = res.data
        }
      })

      let row96, col96, rowVal96, colVal96

      row96 = this.samplePosition[0]
      rowVal96 = this.rowHeaders384.indexOf(row96)
      rowVal96 = rowVal96 == 0 ? rowVal96 : rowVal96 - 1

      col96 = this.samplePosition.slice(1,)
      colVal96 = this.columnHeaders384.indexOf(Number(col96))
      colVal96 = colVal96 == 0 ? colVal96 : colVal96 - 1
      let val96 = this.convert384To96Index(rowVal96, colVal96, this.plateMap.get(this.getPosition(rowVal96, colVal96)))

      this.orgPosition = val96
      this.samplePopVisible = true;
    }
  }

  getPosition(row: number, col: number) {
    let pos = ''
    pos = pos + this.rowHeaders384[row] + this.columnHeaders384[col]
    return pos
  }


  closeSamplePopup() {
    if (this.commentView == true && this.newComment.length > 0) {
      let commentAdded = {
        "comment": this.newComment,
        "puid": this.puid,
        "status": '',
        "timeStamp": new Date()
      }
      this.platePreparationService.updateSampleComment(this.selectedLabId, this.sampleID, commentAdded).subscribe(res => {
        if (res.data) {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Comment is updated',
            detail: 'Comment for sample ' + this.sampleID + ' has been updated successfully'
          })
        }
        else {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Comment update failed',
            detail: 'Comment failed to be added to sample ' + this.sampleID + ' has been updated successfully'
          });
        }
      })
    }
    this.newComment = ''
    this.samplePopVisible = false;
    this.commentView = false;

  }

  convertUtcToLocal(date: any): Date {
    if (!date || date == null) return;
    if (date[date.length - 1] == 'Z')
      date = date.substring(0, date.length - 1)
    let dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes());
    return dateInLocal;
  }

  toggleCommentView() {
    this.commentView = !this.commentView
  }

  getColor(row: number, col: number, mapOfBatch) {
    if (row % 2 == 0 && col % 2 == 0 && mapOfBatch.get(this.getPosition(row, col))) {
      //plate1
      this.color = "#FFC90E";
      this.circleBorder = "#FFC90E";
      this.circleStroke = "3";
    }
    else if (row % 2 == 0 && col % 2 != 0 && mapOfBatch.get(this.getPosition(row, col))) {
      //plate2
      this.color = "#00CE00";
      this.circleBorder = "#00CE00";
      this.circleStroke = "3";
    }
    else if (row % 2 != 0 && col % 2 == 0 && mapOfBatch.get(this.getPosition(row, col))) {
      //plate3
      this.color = "#EE82EE";
      this.circleBorder = "#EE82EE";
      this.circleStroke = "3";
    }
    else if (row % 2 != 0 && col % 2 != 0 && mapOfBatch.get(this.getPosition(row, col))) {
      //plate4
      this.color = "#00FFFF";
      this.circleBorder = "#00FFFF";
      this.circleStroke = "3";
    }
    else {
      //none
      this.color = "white";
      this.circleBorder = "black";
      this.circleStroke = "3";
    }
  }
}
